module.exports = __webpack_public_path__ + "img/ic-new-product-green.b48db95a.svg";